export {PROJECT_ROUTES} from '@common/projects/common-projects.consts';

export const PROJECTS_FEATURES = ['models',' experiments', 'overview'];
